/**
 * Companies
 *
 * @return {object} Companies object
 */
export function getCompanies() {
    return {
        'A-Point': 'A-Point',
        'Alta' : 'Alta',
        'Auto Hoogenboom B.V.' : 'Auto Hoogenboom B.V.',
        'AVFI' : 'AVFI',
        'B2Bike' : 'B2Bike',
        'BBB Cycling' : 'BBB Cycling',
        'Bike Mobility Services B.V.' : 'Bike Mobility Services B.V.',
        'Bolier' : 'Bolier',
        'Business Bike Germany' : 'Business Bike Germany',
        'Cannondale' : 'Cannondale',
        'CSI Oil&Gas' : 'CSI Oil&Gas',
        'Diesel Power Holland B.V.' : 'Diesel Power Holland B.V.',
        'Digital Innovation Lab' : 'Digital Innovation Lab',
        'Digital Solutions' : 'Digital Solutions',
        'Dockr B.V.' : 'Dockr B.V.',
        'Encord' : 'Encord',
        'Energyst' : 'Energyst',
        'Euro-Tyre' : 'Euro-Tyre',
        'Exion Asia' : 'Exion Asia',
        'FietsNED BV' : 'FietsNED BV',
        'Fleetmanagement' : 'Fleetmanagement',
        'FOCUS' : 'FOCUS',
        'GENEX' : 'GENEX',
        'Hely' : 'Hely',
        'Huiskes-Kokkeler Autogroep' : 'Huiskes-Kokkeler Autogroep',
        'IMS Group B.V.' : 'IMS Group B.V.',
        'indiGO Auto Group' : 'indiGO Auto Group',
        'Jetstream' : 'Jetstream',
        'Juliana' : 'Juliana',
        'Kalkhoff' : 'Kalkhoff',
        'Koninklijke Gazelle N.V.' : 'Koninklijke Gazelle N.V.',
        'LEASE A BIKE' : 'LEASE A BIKE',
        'Lensor' : 'Lensor',
        'Machinefabriek Bolier B.V.' : 'Machinefabriek Bolier B.V.',
        'MAN Nederland Dealer B.V.' : 'MAN Nederland Dealer B.V.',
        'MAN Rollo B.V.' : 'MAN Rollo B.V.',
        'MAN Truck & Bus B.V.' : 'MAN Truck & Bus B.V.',
        'Mobility Solutions and Services B.V.' : 'Mobility Solutions and Services B.V.',
        'ModiForce B.V.' : 'ModiForce B.V.',
        'Move' : 'Move',
        'Movelo' : 'Movelo',
        'Muntstad' : 'Muntstad',
        'Orion Complex Fleets B.V.' : 'Orion Complex Fleets B.V.',
        'OrionPartners B.V.' : 'OrionPartners B.V.',
        'PEAK' : 'PEAK',
        'PEPP Holding' : 'PEPP Holding',
        'Pon Bicycle Holding B.V.' : 'Pon Bicycle Holding B.V.',
        'Pon Datalab' : 'Pon Datalab',
        'Pon Dealer' : 'Pon Dealer',
        'Pon Equipment and Pon Power B.V.' : 'Pon Equipment and Pon Power B.V.',
        'Pon Equipment B.V.' : 'Pon Equipment B.V.',
        'Pon Holdings B.V.' : 'Pon Holdings B.V.',
        'Pon HR Services B.V.' : 'Pon HR Services B.V.',
        'Pon IT B.V.' : 'Pon IT B.V.',
        'Pon Logistics bv' : 'Pon Logistics bv',
        'Pon Luxury Cars B.V. / PPI' : 'Pon Luxury Cars B.V. / PPI',
        'Pon Power B.V.' : 'Pon Power B.V.',
        'Pon Power Norway' : 'Pon Power Norway',
        'Pon\'s Automobielhandel B.V.' : 'Pon\'s Automobielhandel B.V.',
        'Ponooc Investment B.V.' : 'Ponooc Investment B.V.',
        'Porsche centrum Amsterdam' : 'Porsche centrum Amsterdam',
        'Radio Holland Group' : 'Radio Holland Group',
        'Revolt' : 'Revolt',
        'RH Marine' : 'RH Marine',
        'Ride-Out B.V.' : 'Ride-Out B.V.',
        'SAF Benelux' : 'SAF Benelux',
        'Shuttel B.V.' : 'Shuttel B.V.',
        'Sitech' : 'Sitech',
        'Stichting Pensioenfonds Pon' : 'Stichting Pensioenfonds Pon',
        'Topec' : 'Topec',
        'Union' : 'Union',
        'Urban Arrow' : 'Urban Arrow',
        'URUS' : 'URUS',
        'VBH' : 'VBH',
        'Verachtert' : 'Verachtert',
        'other': 'Anders, namelijk...'
    };
}

/**
 * Selected Companies (for quiz)
 *
 * @return {object} Companies object
 */
export function getSelectedCompanies() {
    return {
        'PPI': 'PPI',
        'Porsche Centrum Leusden': 'Porsche Centrum Leusden',
        'Porsche Centrum Rotterdam': 'Porsche Centrum Rotterdam',
        'Porsche Centrum Amsterdam': 'Porsche Centrum Amsterdam',
        'BL Leusden': 'BL Leusden',
        'BBL Rotterdam': 'BBL Rotterdam'
    };
}
